// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes ink-enter {
  from {
    opacity: 0;
    transform: translateY(8px);
  }
  to {
    opacity: 1;
    transform: none;
  }
}
.profession-menu-overlay {
  position: fixed;
  inset: 0;
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(2, 3, 8, 0.6);
  pointer-events: none;
  font-family: "Din-pro", "Segoe UI", system-ui, sans-serif;
}

.profession-menu-shell {
  font-family: "Din-pro", "Segoe UI", system-ui, sans-serif;
  color: #ebe8e1;
  background: rgba(11, 15, 19, 0.96);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 6px;
  box-shadow: 0 18px 50px rgba(0, 0, 0, 0.6);
  backdrop-filter: blur(6px);
  pointer-events: auto;
  position: relative;
  width: clamp(880px, 92vw, 1500px);
  height: min(760px, 92vh);
  overflow: hidden;
  display: flex;
  flex-direction: column;
  animation: ink-enter 0.16s ease-out;
}
.profession-menu-shell * {
  box-sizing: border-box;
}
@media (prefers-reduced-motion: reduce) {
  .profession-menu-shell {
    animation: none;
  }
}

.profession-menu-header {
  flex: 0 0 auto;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 2px;
  padding: 18px 24px 14px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.12);
}
.profession-menu-header__brand {
  font-size: 13px;
  font-weight: 600;
  color: #8d8a82;
}
.profession-menu-header__title {
  font-family: "Marcellus", "Cinzel", Georgia, serif;
  font-weight: 400;
  font-size: 26px;
  line-height: 1.15;
  letter-spacing: 0.01em;
  color: #ebe8e1;
  margin: 0;
}
.profession-menu-header__tagline {
  margin-top: 4px;
  font-size: 14px;
  color: #aeaba2;
}

.profession-menu-body {
  overflow-y: auto;
  scrollbar-width: thin;
  scrollbar-color: rgba(255, 255, 255, 0.2) transparent;
  flex: 1 1 auto;
  min-height: 0;
  display: grid;
  grid-template-columns: 29% 1px 1fr 1px 29%;
  gap: 20px;
  padding: 16px 24px;
  scrollbar-gutter: stable;
}
.profession-menu-body::-webkit-scrollbar {
  width: 6px;
}
.profession-menu-body::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.2);
  border-radius: 3px;
}

.profession-menu-heading {
  font-family: "Marcellus", "Cinzel", Georgia, serif;
  font-weight: 400;
  font-size: 17px;
  line-height: 1.15;
  letter-spacing: 0.01em;
  color: #ebe8e1;
  margin-bottom: 8px;
}

.profession-menu-divider {
  align-self: stretch;
  background: rgba(255, 255, 255, 0.12);
}

.profession-menu-categories,
.profession-menu-detail,
.profession-menu-info {
  min-width: 0;
}

.profession-menu-categories {
  display: flex;
  flex-direction: column;
  grid-column: 1;
  min-height: 0;
}

.profession-menu-category-groups {
  overflow-y: auto;
  scrollbar-width: thin;
  scrollbar-color: rgba(255, 255, 255, 0.2) transparent;
  flex: 1 1 auto;
  min-height: 0;
  padding-right: 8px;
  scrollbar-gutter: stable;
}
.profession-menu-category-groups::-webkit-scrollbar {
  width: 6px;
}
.profession-menu-category-groups::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.2);
  border-radius: 3px;
}

.profession-menu-category-group + .profession-menu-category-group {
  margin-top: 16px;
}
.profession-menu-category-group__label {
  margin-bottom: 4px;
  font-size: 13px;
  font-weight: 600;
  color: #aeaba2;
}

.profession-menu-category-list {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
}
.profession-menu-category-list li {
  min-width: 0;
}

.profession-menu-category {
  position: relative;
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
  padding: 9px 12px;
  font-family: "Din-pro", "Segoe UI", system-ui, sans-serif;
  text-align: left;
  color: #aeaba2;
  background: transparent;
  border: 0;
  border-top: 1px solid rgba(255, 255, 255, 0.12);
  border-left: 2px solid transparent;
  cursor: pointer;
  transition: background-color 0.12s ease, color 0.12s ease, border-color 0.12s ease;
}
.profession-menu-category:focus-visible {
  outline: 2px solid var(--gold-light);
  outline-offset: -2px;
}
.profession-menu-category__icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  flex-shrink: 0;
  color: #aeaba2;
}
.profession-menu-category__icon svg {
  width: 22px;
  height: 22px;
}
.profession-menu-category__icon img {
  width: 28px;
  height: 28px;
  object-fit: contain;
  image-rendering: pixelated;
}
.profession-menu-category__text {
  display: flex;
  flex-direction: column;
  min-width: 0;
  line-height: 1.3;
}
.profession-menu-category__name {
  font-size: 15px;
  font-weight: 600;
}
.profession-menu-category__desc {
  font-size: 13px;
  color: #8d8a82;
}
.profession-menu-category__badge {
  position: absolute;
  top: 50%;
  right: 10px;
  width: 8px;
  height: 8px;
  margin-top: -4px;
  border-radius: 50%;
  background: var(--gold-main);
}
.profession-menu-category:hover {
  background: rgba(255, 255, 255, 0.04);
  color: #ebe8e1;
}
.profession-menu-category:hover .profession-menu-category__icon {
  color: var(--gold-light);
}
.profession-menu-category--selected {
  color: #ebe8e1;
  background: rgba(255, 255, 255, 0.04);
  border-left-color: var(--gold-main);
}
.profession-menu-category--selected .profession-menu-category__icon {
  color: var(--gold-light);
}
.profession-menu-category--current .profession-menu-category__name {
  color: var(--gold-light);
}
.profession-menu-category--locked:not(.profession-menu-category--current) {
  opacity: 0.5;
}
.profession-menu-category--suspended {
  opacity: 0.55;
}
.profession-menu-category--suspended .profession-menu-category__badge {
  background: #8d8a82;
}

.profession-menu-suspended-tag {
  display: inline-block;
  margin-left: 8px;
  padding: 1px 7px;
  border: 1px solid #8d8a82;
  border-radius: 2px;
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  vertical-align: middle;
  color: #aeaba2;
}

.profession-menu-detail--suspended .profession-menu-detail__hero-icon,
.profession-menu-detail--suspended .profession-menu-ladder,
.profession-menu-detail--suspended .profession-menu-progress-bar {
  opacity: 0.5;
}

.profession-menu-categories__hint {
  margin-top: auto;
  padding-top: 12px;
  font-size: 13px;
  line-height: 1.5;
  color: #8d8a82;
}

.profession-menu-detail {
  grid-column: 3;
  display: flex;
  flex-direction: column;
  align-items: stretch;
}
.profession-menu-detail__title {
  font-family: "Marcellus", "Cinzel", Georgia, serif;
  font-weight: 400;
  font-size: 26px;
  line-height: 1.15;
  letter-spacing: 0.01em;
  color: #ebe8e1;
  margin: 0 0 12px;
}
.profession-menu-detail__hero {
  width: 100%;
  height: 84px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin-bottom: 12px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.12);
}
.profession-menu-detail__hero-icon {
  width: 44px;
  height: 44px;
  color: var(--gold-main);
}
.profession-menu-detail__hero-icon img {
  width: 56px;
  height: 56px;
  object-fit: contain;
  image-rendering: pixelated;
}
.profession-menu-detail__description {
  max-width: 60ch;
  margin: 0 0 16px;
  font-size: 15px;
  line-height: 1.5;
  color: #aeaba2;
}

.profession-menu-section {
  width: 100%;
  margin-bottom: 16px;
}

.profession-menu-stats {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.profession-menu-stat {
  display: grid;
  grid-template-columns: 110px 1fr 32px;
  align-items: center;
  gap: 12px;
  font-size: 14px;
}
.profession-menu-stat__label {
  color: #aeaba2;
  text-align: left;
}
.profession-menu-stat__pips {
  display: flex;
  gap: 3px;
}
.profession-menu-stat__pip {
  flex: 1;
  height: 6px;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 2px;
}
.profession-menu-stat__pip--filled {
  background: var(--gold-main);
}
.profession-menu-stat__value {
  color: #ebe8e1;
  text-align: right;
  font-variant-numeric: tabular-nums;
}

.profession-menu-endurance-section {
  margin-top: 20px;
}

.profession-menu-endurance {
  display: flex;
  align-items: center;
  gap: 10px;
}
.profession-menu-endurance__value {
  flex: 0 0 auto;
  font-size: 13px;
  color: #aeaba2;
  font-variant-numeric: tabular-nums;
}

.profession-menu-ladder {
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 16px;
  margin-top: 8px;
}

.profession-menu-diamond {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 104px;
  flex-shrink: 0;
  opacity: 0.55;
  transition: opacity 0.15s ease;
}
@media (prefers-reduced-motion: reduce) {
  .profession-menu-diamond {
    transition: none;
  }
}
.profession-menu-diamond__shape {
  width: 14px;
  height: 14px;
  border-radius: 50%;
  border: 2px solid #8d8a82;
  background: transparent;
}
.profession-menu-diamond__rank {
  margin-top: 8px;
  font-size: 14px;
  font-weight: 600;
  color: #aeaba2;
  white-space: nowrap;
}
.profession-menu-diamond__xp {
  margin-top: 2px;
  font-size: 13px;
  color: #8d8a82;
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
}
.profession-menu-diamond__reward {
  margin-top: 6px;
  min-height: 2.8em;
  font-size: 13px;
  line-height: 1.4;
  color: #8d8a82;
}
.profession-menu-diamond--reached {
  opacity: 1;
}
.profession-menu-diamond--reached .profession-menu-diamond__shape {
  border-color: var(--gold-main);
  background: var(--gold-main);
}
.profession-menu-diamond--reached .profession-menu-diamond__rank {
  color: #ebe8e1;
}
.profession-menu-diamond--reached .profession-menu-diamond__xp {
  color: var(--gold-main);
}
.profession-menu-diamond--reached .profession-menu-diamond__reward {
  color: #aeaba2;
}
.profession-menu-diamond--current {
  opacity: 1;
}
.profession-menu-diamond--current .profession-menu-diamond__shape {
  border-color: var(--gold-light);
  background: var(--gold-light);
}
.profession-menu-diamond--current .profession-menu-diamond__rank,
.profession-menu-diamond--current .profession-menu-diamond__xp,
.profession-menu-diamond--current .profession-menu-diamond__reward {
  color: var(--gold-light);
}
.profession-menu-diamond--capped {
  opacity: 0.3;
}
.profession-menu-diamond--capped .profession-menu-diamond__shape {
  border-style: dashed;
}

.profession-menu-progress-bar {
  width: 100%;
  height: 6px;
  margin-top: 16px;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 6px;
  overflow: hidden;
}
.profession-menu-progress-bar--hidden {
  visibility: hidden;
}
.profession-menu-progress-bar__fill {
  height: 100%;
  background: var(--gold-main);
  transition: width 0.25s ease-out;
}
@media (prefers-reduced-motion: reduce) {
  .profession-menu-progress-bar__fill {
    transition: none;
  }
}

.profession-menu-progress-text {
  margin-top: 8px;
  font-size: 13px;
  color: #aeaba2;
  font-variant-numeric: tabular-nums;
}
.profession-menu-progress-text--hidden {
  visibility: hidden;
}

.profession-menu-endurance-bar {
  flex: 1;
  height: 6px;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 6px;
  overflow: hidden;
}
.profession-menu-endurance-bar__fill {
  height: 100%;
  background: #8fbf8a;
  transition: width 0.25s ease-out;
}
@media (prefers-reduced-motion: reduce) {
  .profession-menu-endurance-bar__fill {
    transition: none;
  }
}

.profession-menu-info {
  grid-column: 5;
  display: flex;
  flex-direction: column;
}

.profession-menu-infolist {
  margin: 0 0 20px;
}
.profession-menu-infolist div {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  gap: 10px;
  padding: 8px 0;
  font-size: 14px;
  border-top: 1px solid rgba(255, 255, 255, 0.12);
}
.profession-menu-infolist dt {
  color: #aeaba2;
}
.profession-menu-infolist dd {
  margin: 0;
  color: #ebe8e1;
  display: flex;
  align-items: center;
  gap: 8px;
}

.profession-menu-difficulty-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  display: inline-block;
  background: #8d8a82;
}
.profession-menu-difficulty-dot--facile {
  background: #8fbf8a;
}
.profession-menu-difficulty-dot--moyen {
  background: #d4a455;
}
.profession-menu-difficulty-dot--difficile {
  background: #d9786d;
}

.profession-menu-checklist {
  list-style: none;
  margin: 0 0 20px;
  padding: 0;
  display: flex;
  flex-direction: column;
}
.profession-menu-checklist li {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
  padding: 8px 0;
  font-size: 14px;
  color: #aeaba2;
  border-top: 1px solid rgba(255, 255, 255, 0.12);
}
.profession-menu-checklist__check {
  flex: none;
  width: 5px;
  height: 10px;
  margin-right: 4px;
  border-right: 2px solid var(--gold-main);
  border-bottom: 2px solid var(--gold-main);
  transform: rotate(45deg);
}

.profession-menu-tools {
  display: flex;
  flex-direction: column;
}

.profession-menu-tool {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 8px 0;
  border-top: 1px solid rgba(255, 255, 255, 0.12);
}
.profession-menu-tool__icon {
  width: 40px;
  height: 40px;
  flex-shrink: 0;
  color: var(--gold-main);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 4px;
}
.profession-menu-tool__icon svg {
  width: 100%;
  height: 100%;
}
.profession-menu-tool__icon img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  image-rendering: pixelated;
}
.profession-menu-tool__name {
  font-size: 14px;
  color: #ebe8e1;
}

.profession-menu-footer {
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  padding: 12px 24px;
  border-top: 1px solid rgba(255, 255, 255, 0.12);
}
.profession-menu-footer__hint {
  flex: 1;
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  color: #8d8a82;
}
.profession-menu-footer__hint kbd {
  font-family: "Din-pro", "Segoe UI", system-ui, sans-serif;
  font-size: 12px;
  padding: 2px 8px;
  color: #aeaba2;
  background: rgba(255, 255, 255, 0.04);
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 4px;
}
.profession-menu-footer__spacer {
  flex: 1;
  display: flex;
  justify-content: flex-end;
}

.profession-menu-reroll-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 8px 14px;
  font-family: "Din-pro", "Segoe UI", system-ui, sans-serif;
  font-size: 14px;
  font-weight: 600;
  line-height: 1.2;
  white-space: nowrap;
  color: #ebe8e1;
  background: rgba(255, 255, 255, 0.07);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 6px;
  cursor: pointer;
  transition: background-color 0.12s ease, border-color 0.12s ease, color 0.12s ease;
  color: #8d8a82;
  background: transparent;
  border-color: transparent;
  padding: 5px 10px;
  font-size: 13px;
}
.profession-menu-reroll-btn:hover:not(:disabled) {
  background: rgba(255, 255, 255, 0.12);
  border-color: var(--gold-dark);
}
.profession-menu-reroll-btn:active:not(:disabled) {
  transform: translateY(1px);
}
.profession-menu-reroll-btn:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}
.profession-menu-reroll-btn:focus-visible {
  outline: 2px solid var(--gold-light);
  outline-offset: 2px;
}
.profession-menu-reroll-btn:hover:not(:disabled) {
  color: #ebe8e1;
  background: rgba(255, 255, 255, 0.07);
  border-color: transparent;
}
.profession-menu-reroll-btn:hover:not(:disabled) {
  color: #d9786d;
  background: rgba(217, 120, 109, 0.14);
}

.profession-menu-choose-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 8px 14px;
  font-family: "Din-pro", "Segoe UI", system-ui, sans-serif;
  font-size: 14px;
  font-weight: 600;
  line-height: 1.2;
  white-space: nowrap;
  color: #ebe8e1;
  background: rgba(255, 255, 255, 0.07);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 6px;
  cursor: pointer;
  transition: background-color 0.12s ease, border-color 0.12s ease, color 0.12s ease;
  color: #14100a;
  background: var(--gold-main);
  border-color: var(--gold-main);
  padding: 10px 28px;
}
.profession-menu-choose-btn:hover:not(:disabled) {
  background: rgba(255, 255, 255, 0.12);
  border-color: var(--gold-dark);
}
.profession-menu-choose-btn:active:not(:disabled) {
  transform: translateY(1px);
}
.profession-menu-choose-btn:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}
.profession-menu-choose-btn:focus-visible {
  outline: 2px solid var(--gold-light);
  outline-offset: 2px;
}
.profession-menu-choose-btn:hover:not(:disabled) {
  background: var(--gold-light);
  border-color: var(--gold-light);
}
.profession-menu-choose-btn:disabled {
  color: #8d8a82;
  background: rgba(255, 255, 255, 0.05);
  border-color: rgba(255, 255, 255, 0.12);
}
.profession-menu-choose-btn--current:disabled {
  color: var(--gold-light);
  border-color: var(--gold-dark);
}

.profession-menu-confirm-overlay {
  position: absolute;
  inset: 0;
  z-index: 3;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(2, 3, 5, 0.72);
  animation: ink-enter 0.16s ease-out;
}
@media (prefers-reduced-motion: reduce) {
  .profession-menu-confirm-overlay {
    animation: none;
  }
}

.profession-menu-confirm {
  font-family: "Din-pro", "Segoe UI", system-ui, sans-serif;
  color: #ebe8e1;
  background: rgba(11, 15, 19, 0.96);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 6px;
  box-shadow: 0 18px 50px rgba(0, 0, 0, 0.6);
  backdrop-filter: blur(6px);
  width: min(460px, 86%);
  padding: 22px 24px;
}
.profession-menu-confirm * {
  box-sizing: border-box;
}
.profession-menu-confirm__title {
  font-family: "Marcellus", "Cinzel", Georgia, serif;
  font-weight: 400;
  font-size: 22px;
  line-height: 1.15;
  letter-spacing: 0.01em;
  color: #ebe8e1;
  margin-bottom: 12px;
}
.profession-menu-confirm__text {
  margin: 0 0 4px;
  font-size: 15px;
  line-height: 1.5;
  color: #aeaba2;
}
.profession-menu-confirm__profession {
  display: block;
  margin: 6px 0 12px;
  font-family: "Marcellus", "Cinzel", Georgia, serif;
  font-weight: 400;
  font-size: 20px;
  line-height: 1.15;
  letter-spacing: 0.01em;
  color: #ebe8e1;
  color: var(--gold-light);
}
.profession-menu-confirm__note {
  margin-bottom: 18px;
  font-size: 13px;
  line-height: 1.5;
  color: #8d8a82;
}
.profession-menu-confirm__actions {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
}

.profession-menu-confirm-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 8px 14px;
  font-family: "Din-pro", "Segoe UI", system-ui, sans-serif;
  font-size: 14px;
  font-weight: 600;
  line-height: 1.2;
  white-space: nowrap;
  color: #ebe8e1;
  background: rgba(255, 255, 255, 0.07);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 6px;
  cursor: pointer;
  transition: background-color 0.12s ease, border-color 0.12s ease, color 0.12s ease;
}
.profession-menu-confirm-btn:hover:not(:disabled) {
  background: rgba(255, 255, 255, 0.12);
  border-color: var(--gold-dark);
}
.profession-menu-confirm-btn:active:not(:disabled) {
  transform: translateY(1px);
}
.profession-menu-confirm-btn:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}
.profession-menu-confirm-btn:focus-visible {
  outline: 2px solid var(--gold-light);
  outline-offset: 2px;
}
.profession-menu-confirm-btn--confirm {
  color: #14100a;
  background: var(--gold-main);
  border-color: var(--gold-main);
}
.profession-menu-confirm-btn--confirm:hover:not(:disabled) {
  background: var(--gold-light);
  border-color: var(--gold-light);
}
.profession-menu-confirm-btn--danger {
  color: #d9786d;
  background: transparent;
  border-color: rgba(217, 120, 109, 0.45);
}
.profession-menu-confirm-btn--danger:hover:not(:disabled) {
  background: rgba(217, 120, 109, 0.14);
  border-color: #d9786d;
}`, "",{"version":3,"sources":["webpack://./src/theme/_ink.scss","webpack://./src/features/professionsMenu/styles.scss"],"names":[],"mappings":"AAmLA;EACE;IAAO,UAAA;IAAY,0BAAA;EChLnB;EDiLA;IAAO,UAAA;IAAY,eAAA;EC7KnB;AACF;AADA;EACE,eAAA;EACA,QAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,8BAAA;EACA,oBAAA;EACA,yDDaU;ACVZ;;AAAA;EDaE,yDAHU;EAIV,cAbK;EAoBL,kCAzBI;EA0BJ,0CAAA;EACA,kBAjBO;EAkBP,0CAAA;EACA,0BAAA;ECvBA,oBAAA;EACA,kBAAA;EAEA,iCAAA;EAGA,wBAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;ED+IA,mCAAA;ACxIF;ADHE;EAAI,sBAAA;ACMN;ADuIE;EC5JF;ID4J4C,eAAA;ECnI1C;AACF;;AATA;EACE,cAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,QAAA;EACA,uBAAA;EACA,kDAAA;AAYF;AAVE;EACE,eAAA;EACA,gBAAA;EACA,cD1BK;ACsCT;AATE;EDIA,kDA3BW;EA4BX,gBAAA;EACA,eCLqB;EDMrB,iBAAA;EACA,sBAAA;EACA,cAxCK;ECiCH,SAAA;AAgBJ;AAbE;EACE,eAAA;EACA,eAAA;EACA,cDtCK;ACqDT;;AATA;EDmGE,gBAAA;EACA,qBAAA;EACA,qDAAA;ECnGA,cAAA;EACA,aAAA;EACA,aAAA;EACA,0CAAA;EACA,SAAA;EACA,kBAAA;EACA,wBAAA;AAcF;ADiFE;EAAuB,UAAA;AC9EzB;AD+EE;EAA6B,oCAAA;EAAsC,kBAAA;AC3ErE;;AAlBA;EDrBE,kDA3BW;EA4BX,gBAAA;EACA,eCoBmB;EDnBnB,iBAAA;EACA,sBAAA;EACA,cAxCK;EC0DL,kBAAA;AA0BF;;AAvBA;EACE,mBAAA;EACA,qCDjEK;AC2FP;;AAvBA;;;EAGE,YAAA;AA0BF;;AAvBA;EACE,aAAA;EACA,sBAAA;EACA,cAAA;EAGA,aAAA;AAwBF;;AApBA;ED8DE,gBAAA;EACA,qBAAA;EACA,qDAAA;EC9DA,cAAA;EACA,aAAA;EACA,kBAAA;EACA,wBAAA;AAyBF;ADoCE;EAAuB,UAAA;ACjCzB;ADkCE;EAA6B,oCAAA;EAAsC,kBAAA;AC9BrE;;AA5BE;EACE,gBAAA;AA+BJ;AA5BE;EACE,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,cDlGK;ACgIT;;AA1BA;EACE,gBAAA;EACA,SAAA;EACA,UAAA;EACA,aAAA;EACA,sBAAA;AA6BF;AA3BE;EACE,YAAA;AA6BJ;;AAxBA;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;EACA,WAAA;EACA,iBAAA;EACA,yDDlHU;ECmHV,gBAAA;EACA,cD5HO;EC6HP,uBAAA;EACA,SAAA;EACA,+CAAA;EACA,kCAAA;EACA,eAAA;EACA,kFAAA;AA2BF;AAzBE;EACE,oCAAA;EACA,oBAAA;AA2BJ;AAxBE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,cDhJK;AC0KT;AAxBI;EAAM,WAAA;EAAa,YAAA;AA4BvB;AA1BI;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,0BAAA;AA4BN;AAxBE;EACE,aAAA;EACA,sBAAA;EACA,YAAA;EACA,gBAAA;AA0BJ;AAvBE;EACE,eAAA;EACA,gBAAA;AAyBJ;AAtBE;EACE,eAAA;EACA,cDzKK;ACiMT;AApBE;EACE,kBAAA;EACA,QAAA;EACA,WAAA;EACA,UAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,4BAAA;AAsBJ;AAnBE;EACE,qCD/LS;ECgMT,cD5LG;ACiNP;AAnBI;EAAkC,wBAAA;AAsBtC;AAnBE;EACE,cDlMG;ECmMH,qCDvMS;ECwMT,mCAAA;AAqBJ;AAnBI;EAAkC,wBAAA;AAsBtC;AAlBI;EAAkC,wBAAA;AAqBtC;AAhBE;EACE,YAAA;AAkBJ;AAdE;EACE,aAAA;AAgBJ;AAdI;EAAmC,mBDrN9B;ACsOT;;AAbA;EACE,qBAAA;EACA,gBAAA;EACA,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,yBAAA;EACA,sBAAA;EACA,cDrOO;ACqPT;;AAZE;;;EAGE,YAAA;AAeJ;;AAXA;EACE,gBAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,cDpPO;ACkQT;;AATA;EACE,cAAA;EACA,aAAA;EACA,sBAAA;EACA,oBAAA;AAYF;AAVE;ED9NA,kDA3BW;EA4BX,gBAAA;EACA,eC6NqB;ED5NrB,iBAAA;EACA,sBAAA;EACA,cAxCK;ECmQH,gBAAA;AAiBJ;AAdE;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,mBAAA;EACA,kDAAA;AAgBJ;AAbE;EACE,WAAA;EACA,YAAA;EACA,uBAAA;AAeJ;AAXI;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,0BAAA;AAaN;AATE;EACE,eAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,cDnSK;AC8ST;;AAPA;EACE,WAAA;EACA,mBAAA;AAUF;;AAPA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AAUF;;AAPA;EACE,aAAA;EACA,qCAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;AAUF;AARE;EACE,cD1TK;EC2TL,gBAAA;AAUJ;AAPE;EACE,aAAA;EACA,QAAA;AASJ;AANE;EACE,OAAA;EACA,WAAA;EACA,oCAAA;EACA,kBAAA;AAQJ;AANI;EACE,4BAAA;AAQN;AAJE;EACE,cDhVG;ECiVH,iBAAA;EACA,kCAAA;AAMJ;;AAFA;EACE,gBAAA;AAKF;;AAFA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AAKF;AAHE;EACE,cAAA;EACA,eAAA;EACA,cDjWK;ECkWL,kCAAA;AAKJ;;AACA;EACE,aAAA;EACA,2BAAA;EACA,uBAAA;EACA,SAAA;EACA,eAAA;AAEF;;AACA;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,YAAA;EACA,cAAA;EACA,aAAA;EACA,8BAAA;AAEF;AAAE;EATF;IAS4C,gBAAA;EAI1C;AACF;AAHE;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;EACA,uBAAA;AAKJ;AAFE;EACE,eAAA;EACA,eAAA;EACA,gBAAA;EACA,cDvYK;ECwYL,mBAAA;AAIJ;AADE;EACE,eAAA;EACA,eAAA;EACA,cD7YK;EC8YL,kCAAA;EACA,mBAAA;AAGJ;AAAE;EACE,eAAA;EAGA,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,cDzZK;ACyZT;AAGE;EACE,UAAA;AADJ;AAGI;EACE,8BAAA;EACA,4BAAA;AADN;AAGI;EAAiC,cDra9B;ACqaP;AACI;EAA+B,uBAAA;AAEnC;AADI;EAAmC,cDta9B;AC0aT;AADE;EACE,UAAA;AAGJ;AADI;EACE,+BAAA;EACA,6BAAA;AAGN;AADI;;;EAEmC,wBAAA;AAIvC;AACE;EACE,YAAA;AACJ;AACI;EAAkC,oBAAA;AAEtC;;AAEA;EACE,WAAA;EACA,WAAA;EACA,gBAAA;EACA,oCAAA;EACA,kBD/bO;ECgcP,gBAAA;AACF;AACE;EACE,kBAAA;AACJ;AAEE;EACE,YAAA;EACA,4BAAA;EACA,gCAAA;AAAJ;AAEI;EALF;IAK4C,gBAAA;EAE5C;AACF;;AACA;EACE,eAAA;EACA,eAAA;EACA,cDtdO;ECudP,kCAAA;AAEF;AAAE;EACE,kBAAA;AAEJ;;AAIA;EACE,OAAA;EACA,WAAA;EACA,oCAAA;EACA,kBDheO;ECieP,gBAAA;AADF;AAGE;EACE,YAAA;EACA,mBDteM;ECueN,gCAAA;AADJ;AAGI;EALF;IAK4C,gBAAA;EAC5C;AACF;;AAIA;EACE,cAAA;EACA,aAAA;EACA,sBAAA;AADF;;AAIA;EACE,gBAAA;AADF;AAGE;EACE,aAAA;EACA,8BAAA;EACA,qBAAA;EACA,SAAA;EACA,cAAA;EACA,eAAA;EACA,+CAAA;AADJ;AAIE;EAAK,cDrgBE;ACogBT;AAEE;EAAK,SAAA;EAAW,cDvgBX;ECugB6B,aAAA;EAAe,mBAAA;EAAqB,QAAA;AAKxE;;AAFA;EACE,UAAA;EACA,WAAA;EACA,kBAAA;EACA,qBAAA;EACA,mBD7gBO;ACkhBT;AAHE;EAAY,mBD7gBJ;ACmhBV;AALE;EAAW,mBAjiBH;AAyiBV;AAPE;EAAe,mBDhhBR;AC0hBT;;AAPA;EACE,gBAAA;EACA,gBAAA;EACA,UAAA;EACA,aAAA;EACA,sBAAA;AAUF;AARE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,SAAA;EACA,cAAA;EACA,eAAA;EACA,cDniBK;ECoiBL,+CAAA;AAUJ;AANE;EACE,UAAA;EACA,UAAA;EACA,YAAA;EACA,iBAAA;EACA,wCAAA;EACA,yCAAA;EACA,wBAAA;AAQJ;;AAJA;EACE,aAAA;EACA,sBAAA;AAOF;;AAJA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,cAAA;EACA,+CAAA;AAOF;AALE;EACE,WAAA;EACA,YAAA;EACA,cAAA;EACA,uBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;AAOJ;AALI;EACE,WAAA;EACA,YAAA;AAON;AAHI;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,0BAAA;AAKN;AADE;EACE,eAAA;EACA,cD1lBG;AC6lBP;;AAGA;EACE,cAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,+CAAA;AAAF;AAEE;EACE,OAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,cD3mBK;AC2mBT;AAEI;EACE,yDDvmBM;ECwmBN,eAAA;EACA,gBAAA;EACA,cDlnBG;ECmnBH,qCDxnBO;ECynBP,2CAAA;EACA,kBAAA;AAAN;AAIE;EACE,OAAA;EACA,aAAA;EACA,yBAAA;AAFJ;;AAOA;EDnkBE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,iBAAA;EACA,yDA3DU;EA4DV,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAzEK;EA0EL,qCAAA;EACA,0CAAA;EACA,kBAvEO;EAwEP,eAAA;EACA,kFAAA;EAyBA,cArGO;EAsGP,uBAAA;EACA,yBAAA;EAMA,iBAAA;EACA,eAAA;ACmiBF;ADnkBE;EAAyB,qCAAA;EAAuC,8BAAA;ACukBlE;ADtkBE;EAA0B,0BAAA;ACykB5B;ADxkBE;EAAa,YAAA;EAAc,mBAAA;AC4kB7B;AD3kBE;EAAkB,oCAAA;EAAsC,mBAAA;AC+kB1D;ADvjBE;EAAyB,cA3GpB;EA2GkC,qCAAA;EAAuC,yBAAA;AC4jBhF;AAhCE;EACE,cDroBK;ECsoBL,qCAAA;AAkCJ;;AA7BA;ED/kBE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,iBAAA;EACA,yDA3DU;EA4DV,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAzEK;EA0EL,qCAAA;EACA,0CAAA;EACA,kBAvEO;EAwEP,eAAA;EACA,kFAAA;EASA,cAjFU;EAkFV,4BAAA;EACA,8BAAA;ECwjBA,kBAAA;AAiDF;ADlnBE;EAAyB,qCAAA;EAAuC,8BAAA;ACsnBlE;ADrnBE;EAA0B,0BAAA;ACwnB5B;ADvnBE;EAAa,YAAA;EAAc,mBAAA;AC2nB7B;AD1nBE;EAAkB,oCAAA;EAAsC,mBAAA;AC8nB1D;ADtnBE;EAAyB,6BAAA;EAA+B,+BAAA;AC0nB1D;AAlEE;EACE,cDlpBK;ECmpBL,qCAAA;EACA,uCDxpBG;AC4tBP;AAjEE;EACE,wBAAA;EACA,8BAAA;AAmEJ;;AA7DA;EACE,kBAAA;EACA,QAAA;EACA,UAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,+BAAA;ED/gBA,mCAAA;ACglBF;AD9kBE;ECsgBF;IDtgB4C,eAAA;ECklB1C;AACF;;AAlEA;EDhqBE,yDAHU;EAIV,cAbK;EAoBL,kCAzBI;EA0BJ,0CAAA;EACA,kBAjBO;EAkBP,0CAAA;EACA,0BAAA;ECspBA,sBAAA;EACA,kBAAA;AA2EF;AD5uBE;EAAI,sBAAA;AC+uBN;AA5EE;ED9oBA,kDA3BW;EA4BX,gBAAA;EACA,eC6oBqB;ED5oBrB,iBAAA;EACA,sBAAA;EACA,cAxCK;ECmrBH,mBAAA;AAmFJ;AAhFE;EACE,eAAA;EACA,eAAA;EACA,gBAAA;EACA,cDzrBK;AC2wBT;AA/EE;EACE,cAAA;EACA,kBAAA;ED5pBF,kDA3BW;EA4BX,gBAAA;EACA,eC2pBqB;ED1pBrB,iBAAA;EACA,sBAAA;EACA,cAxCK;ECisBH,wBAAA;AAsFJ;AAnFE;EACE,mBAAA;EDnpBF,eAAA;EACA,gBAAA;EACA,cAlDO;AC2xBT;AApFE;EACE,aAAA;EACA,yBAAA;EACA,QAAA;AAsFJ;;AAlFA;EDjpBE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,iBAAA;EACA,yDA3DU;EA4DV,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAzEK;EA0EL,qCAAA;EACA,0CAAA;EACA,kBAvEO;EAwEP,eAAA;EACA,kFAAA;ACuuBF;ADruBE;EAAyB,qCAAA;EAAuC,8BAAA;ACyuBlE;ADxuBE;EAA0B,0BAAA;AC2uB5B;AD1uBE;EAAa,YAAA;EAAc,mBAAA;AC8uB7B;AD7uBE;EAAkB,oCAAA;EAAsC,mBAAA;ACivB1D;AAjHE;ED5nBA,cAjFU;EAkFV,4BAAA;EACA,8BAAA;ACgvBF;AD9uBE;EAAyB,6BAAA;EAA+B,+BAAA;ACkvB1D;AAtHE;EDxnBA,cA5FO;EA6FP,uBAAA;EACA,uCAAA;ACivBF;AD/uBE;EAAyB,qCAAA;EAAuC,qBAhGzD;ACm1BT","sourcesContent":["// Shared look of the redesigned interfaces (escape menu, ALT menu, housing\n// drawer, and every other panel brought in line with them).\n//\n// Usage from any component stylesheet:\n//   @use '../../theme/ink' as ink;      // adjust the relative path\n//   .my-panel { @include ink.panel; }\n//\n// Rules the whole UI follows:\n//   - ink background, 1px light border, ONE corner radius (6px)\n//   - accent colour only through the palette tokens --gold-main/-light/-dark\n//     (never a hard-coded gold hex), so the palette picker keeps working\n//   - Marcellus for titles, Din-pro for everything else\n//   - no ornaments, no emoji, no centred decorative rules\n//   - hover and focus states on every control, reduced-motion respected\n//   - no color-mix() / relative colour syntax (older CEF in game)\n\n$ink: rgba(11, 15, 19, 0.96);\n$ink-raised: rgba(255, 255, 255, 0.04);\n$ink-field: rgba(0, 0, 0, 0.35);\n$line: rgba(255, 255, 255, 0.12);\n$line-strong: rgba(255, 255, 255, 0.2);\n$text: #ebe8e1;\n$text-2: #aeaba2;\n$text-3: #8d8a82;\n$danger: #d9786d;\n$success: #8fbf8a;\n$radius: 6px;\n$on-accent: #14100a;\n\n$font-title: 'Marcellus', 'Cinzel', Georgia, serif;\n$font-text: 'Din-pro', 'Segoe UI', system-ui, sans-serif;\n\n@mixin base {\n  font-family: $font-text;\n  color: $text;\n  * { box-sizing: border-box; }\n}\n\n// Floating panel (modals, centred prompts, docked windows).\n@mixin panel {\n  @include base;\n  background: $ink;\n  border: 1px solid $line-strong;\n  border-radius: $radius;\n  box-shadow: 0 18px 50px rgba(0, 0, 0, 0.6);\n  backdrop-filter: blur(6px);\n}\n\n// Raised block inside a panel.\n@mixin block {\n  background: $ink-raised;\n  border: 1px solid $line;\n  border-radius: $radius;\n}\n\n@mixin title($size: 22px) {\n  font-family: $font-title;\n  font-weight: 400;\n  font-size: $size;\n  line-height: 1.15;\n  letter-spacing: 0.01em;\n  color: $text;\n}\n\n@mixin lead {\n  font-size: 14px;\n  line-height: 1.5;\n  color: $text-2;\n}\n\n@mixin hint {\n  font-size: 13px;\n  line-height: 1.5;\n  color: $text-3;\n}\n\n@mixin label {\n  font-size: 13px;\n  font-weight: 600;\n  color: $text-2;\n}\n\n// Buttons: neutral by default; add the modifiers below for the other kinds.\n@mixin button {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  padding: 8px 14px;\n  font-family: $font-text;\n  font-size: 14px;\n  font-weight: 600;\n  line-height: 1.2;\n  white-space: nowrap;\n  color: $text;\n  background: rgba(255, 255, 255, 0.07);\n  border: 1px solid $line-strong;\n  border-radius: $radius;\n  cursor: pointer;\n  transition: background-color 0.12s ease, border-color 0.12s ease, color 0.12s ease;\n\n  &:hover:not(:disabled) { background: rgba(255, 255, 255, 0.12); border-color: var(--gold-dark); }\n  &:active:not(:disabled) { transform: translateY(1px); }\n  &:disabled { opacity: 0.4; cursor: not-allowed; }\n  &:focus-visible { outline: 2px solid var(--gold-light); outline-offset: 2px; }\n}\n\n@mixin button-primary {\n  color: $on-accent;\n  background: var(--gold-main);\n  border-color: var(--gold-main);\n\n  &:hover:not(:disabled) { background: var(--gold-light); border-color: var(--gold-light); }\n}\n\n@mixin button-danger {\n  color: $danger;\n  background: transparent;\n  border-color: rgba(217, 120, 109, 0.45);\n\n  &:hover:not(:disabled) { background: rgba(217, 120, 109, 0.14); border-color: $danger; }\n}\n\n@mixin button-quiet {\n  color: $text-3;\n  background: transparent;\n  border-color: transparent;\n\n  &:hover:not(:disabled) { color: $text; background: rgba(255, 255, 255, 0.07); border-color: transparent; }\n}\n\n@mixin button-sm {\n  padding: 5px 10px;\n  font-size: 13px;\n}\n\n@mixin field {\n  width: 100%;\n  padding: 9px 11px;\n  font-family: $font-text;\n  font-size: 14px;\n  color: $text;\n  background: $ink-field;\n  border: 1px solid $line-strong;\n  border-radius: $radius;\n  user-select: text;\n\n  &:focus { outline: none; border-color: var(--gold-main); }\n  &::placeholder { color: $text-3; font-family: $font-text; text-transform: none; letter-spacing: normal; opacity: 1; }\n}\n\n// Pill-shaped counters are the only rounded exception (small badges).\n@mixin badge {\n  display: inline-block;\n  min-width: 20px;\n  padding: 1px 7px;\n  font-size: 12px;\n  font-weight: 600;\n  text-align: center;\n  color: $text-2;\n  background: rgba(255, 255, 255, 0.09);\n  border-radius: 10px;\n}\n\n@mixin scroll {\n  overflow-y: auto;\n  scrollbar-width: thin;\n  scrollbar-color: rgba(255, 255, 255, 0.2) transparent;\n\n  &::-webkit-scrollbar { width: 6px; }\n  &::-webkit-scrollbar-thumb { background: rgba(255, 255, 255, 0.2); border-radius: 3px; }\n}\n\n@mixin enter($from: translateY(8px)) {\n  animation: ink-enter 0.16s ease-out;\n\n  @media (prefers-reduced-motion: reduce) { animation: none; }\n}\n\n@keyframes ink-enter {\n  from { opacity: 0; transform: translateY(8px); }\n  to   { opacity: 1; transform: none; }\n}\n\n// Tabs (underline style, as in the housing drawer).\n@mixin tab {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 9px 12px;\n  margin-bottom: -1px;\n  font-family: $font-text;\n  font-size: 14px;\n  font-weight: 600;\n  color: $text-2;\n  background: transparent;\n  border: 0;\n  border-bottom: 2px solid transparent;\n  cursor: pointer;\n\n  &:hover { color: $text; }\n  &:focus-visible { outline: 2px solid var(--gold-light); outline-offset: -2px; }\n}\n\n@mixin tab-active {\n  color: var(--gold-light);\n  border-bottom-color: var(--gold-main);\n}\n","// Professions menu. Centred window in the shared ink look (see\n// theme/_ink.scss): ink panel, 1px border, one 6px radius, accent only via the\n// palette tokens, rows with a single top divider and an accent bar on the\n// selected one.\n@use '../../theme/ink' as ink;\n\n$warning: #d4a455;\n\n.profession-menu-overlay {\n  position: fixed;\n  inset: 0;\n  z-index: 9999;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: rgba(2, 3, 8, 0.6);\n  pointer-events: none;\n  font-family: ink.$font-text;\n}\n\n.profession-menu-shell {\n  @include ink.panel;\n  pointer-events: auto;\n  position: relative;\n  // clamp() so the window keeps growing on very wide viewports.\n  width: clamp(880px, 92vw, 1500px);\n  // Fixed height (not max-height) on purpose: the window never resizes when\n  // switching between professions with more or less content.\n  height: min(760px, 92vh);\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  @include ink.enter;\n}\n\n// ---------- Header ----------\n\n.profession-menu-header {\n  flex: 0 0 auto;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 2px;\n  padding: 18px 24px 14px;\n  border-bottom: 1px solid ink.$line;\n\n  &__brand {\n    font-size: 13px;\n    font-weight: 600;\n    color: ink.$text-3;\n  }\n\n  &__title {\n    @include ink.title(26px);\n    margin: 0;\n  }\n\n  &__tagline {\n    margin-top: 4px;\n    font-size: 14px;\n    color: ink.$text-2;\n  }\n}\n\n// ---------- Body: 3 columns ----------\n\n.profession-menu-body {\n  @include ink.scroll;\n  flex: 1 1 auto;\n  min-height: 0;\n  display: grid;\n  grid-template-columns: 29% 1px 1fr 1px 29%;\n  gap: 20px;\n  padding: 16px 24px;\n  scrollbar-gutter: stable;\n}\n\n.profession-menu-heading {\n  @include ink.title(17px);\n  margin-bottom: 8px;\n}\n\n.profession-menu-divider {\n  align-self: stretch;\n  background: ink.$line;\n}\n\n.profession-menu-categories,\n.profession-menu-detail,\n.profession-menu-info {\n  min-width: 0;\n}\n\n.profession-menu-categories {\n  display: flex;\n  flex-direction: column;\n  grid-column: 1;\n  // Must stay within the row height the grid gives it so the list scrolls\n  // instead of pushing the fixed-height shell taller.\n  min-height: 0;\n}\n\n// The scroll container: both groups share one scrollbar.\n.profession-menu-category-groups {\n  @include ink.scroll;\n  flex: 1 1 auto;\n  min-height: 0;\n  padding-right: 8px;\n  scrollbar-gutter: stable;\n}\n\n.profession-menu-category-group {\n  & + & {\n    margin-top: 16px;\n  }\n\n  &__label {\n    margin-bottom: 4px;\n    font-size: 13px;\n    font-weight: 600;\n    color: ink.$text-2;\n  }\n}\n\n.profession-menu-category-list {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n\n  li {\n    min-width: 0;\n  }\n}\n\n// One row per profession, single top divider, accent bar when selected.\n.profession-menu-category {\n  position: relative;\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  width: 100%;\n  padding: 9px 12px;\n  font-family: ink.$font-text;\n  text-align: left;\n  color: ink.$text-2;\n  background: transparent;\n  border: 0;\n  border-top: 1px solid ink.$line;\n  border-left: 2px solid transparent;\n  cursor: pointer;\n  transition: background-color 0.12s ease, color 0.12s ease, border-color 0.12s ease;\n\n  &:focus-visible {\n    outline: 2px solid var(--gold-light);\n    outline-offset: -2px;\n  }\n\n  &__icon {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 32px;\n    height: 32px;\n    flex-shrink: 0;\n    color: ink.$text-2;\n\n    svg { width: 22px; height: 22px; }\n\n    img {\n      width: 28px;\n      height: 28px;\n      object-fit: contain;\n      image-rendering: pixelated;\n    }\n  }\n\n  &__text {\n    display: flex;\n    flex-direction: column;\n    min-width: 0;\n    line-height: 1.3;\n  }\n\n  &__name {\n    font-size: 15px;\n    font-weight: 600;\n  }\n\n  &__desc {\n    font-size: 13px;\n    color: ink.$text-3;\n  }\n\n  // Owned profession marker.\n  &__badge {\n    position: absolute;\n    top: 50%;\n    right: 10px;\n    width: 8px;\n    height: 8px;\n    margin-top: -4px;\n    border-radius: 50%;\n    background: var(--gold-main);\n  }\n\n  &:hover {\n    background: ink.$ink-raised;\n    color: ink.$text;\n\n    .profession-menu-category__icon { color: var(--gold-light); }\n  }\n\n  &--selected {\n    color: ink.$text;\n    background: ink.$ink-raised;\n    border-left-color: var(--gold-main);\n\n    .profession-menu-category__icon { color: var(--gold-light); }\n  }\n\n  &--current {\n    .profession-menu-category__name { color: var(--gold-light); }\n  }\n\n  // Not owned and its slot budget is spent: still browsable, visibly not\n  // pickable any more.\n  &--locked:not(&--current) {\n    opacity: 0.5;\n  }\n\n  // Owned but suspended by the staff: dimmed, with a \"Suspendu\" tag.\n  &--suspended {\n    opacity: 0.55;\n\n    .profession-menu-category__badge { background: ink.$text-3; }\n  }\n}\n\n.profession-menu-suspended-tag {\n  display: inline-block;\n  margin-left: 8px;\n  padding: 1px 7px;\n  border: 1px solid ink.$text-3;\n  border-radius: 2px;\n  font-size: 12px;\n  font-weight: 600;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  vertical-align: middle;\n  color: ink.$text-2;\n}\n\n.profession-menu-detail--suspended {\n  .profession-menu-detail__hero-icon,\n  .profession-menu-ladder,\n  .profession-menu-progress-bar {\n    opacity: 0.5;\n  }\n}\n\n.profession-menu-categories__hint {\n  margin-top: auto;\n  padding-top: 12px;\n  font-size: 13px;\n  line-height: 1.5;\n  color: ink.$text-3;\n}\n\n// ---------- Detail (center) ----------\n\n.profession-menu-detail {\n  grid-column: 3;\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n\n  &__title {\n    @include ink.title(26px);\n    margin: 0 0 12px;\n  }\n\n  &__hero {\n    width: 100%;\n    height: 84px;\n    display: flex;\n    align-items: center;\n    justify-content: flex-start;\n    margin-bottom: 12px;\n    border-bottom: 1px solid ink.$line;\n  }\n\n  &__hero-icon {\n    width: 44px;\n    height: 44px;\n    color: var(--gold-main);\n\n    // Real pixel-art tool images read better a bit larger than the line\n    // icons the size above was tuned for.\n    img {\n      width: 56px;\n      height: 56px;\n      object-fit: contain;\n      image-rendering: pixelated;\n    }\n  }\n\n  &__description {\n    max-width: 60ch;\n    margin: 0 0 16px;\n    font-size: 15px;\n    line-height: 1.5;\n    color: ink.$text-2;\n  }\n}\n\n.profession-menu-section {\n  width: 100%;\n  margin-bottom: 16px;\n}\n\n.profession-menu-stats {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.profession-menu-stat {\n  display: grid;\n  grid-template-columns: 110px 1fr 32px;\n  align-items: center;\n  gap: 12px;\n  font-size: 14px;\n\n  &__label {\n    color: ink.$text-2;\n    text-align: left;\n  }\n\n  &__pips {\n    display: flex;\n    gap: 3px;\n  }\n\n  &__pip {\n    flex: 1;\n    height: 6px;\n    background: rgba(255, 255, 255, 0.1);\n    border-radius: 2px;\n\n    &--filled {\n      background: var(--gold-main);\n    }\n  }\n\n  &__value {\n    color: ink.$text;\n    text-align: right;\n    font-variant-numeric: tabular-nums;\n  }\n}\n\n.profession-menu-endurance-section {\n  margin-top: 20px;\n}\n\n.profession-menu-endurance {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n\n  &__value {\n    flex: 0 0 auto;\n    font-size: 13px;\n    color: ink.$text-2;\n    font-variant-numeric: tabular-nums;\n  }\n}\n\n// ---------- Rank ladder ----------\n\n.profession-menu-ladder {\n  display: flex;\n  justify-content: flex-start;\n  align-items: flex-start;\n  gap: 16px;\n  margin-top: 8px;\n}\n\n.profession-menu-diamond {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  width: 104px;\n  flex-shrink: 0;\n  opacity: 0.55;\n  transition: opacity 0.15s ease;\n\n  @media (prefers-reduced-motion: reduce) { transition: none; }\n\n  &__shape {\n    width: 14px;\n    height: 14px;\n    border-radius: 50%;\n    border: 2px solid ink.$text-3;\n    background: transparent;\n  }\n\n  &__rank {\n    margin-top: 8px;\n    font-size: 14px;\n    font-weight: 600;\n    color: ink.$text-2;\n    white-space: nowrap;\n  }\n\n  &__xp {\n    margin-top: 2px;\n    font-size: 13px;\n    color: ink.$text-3;\n    font-variant-numeric: tabular-nums;\n    white-space: nowrap;\n  }\n\n  &__reward {\n    margin-top: 6px;\n    // Two-line reservation so captions of different lengths keep every\n    // column level.\n    min-height: 2.8em;\n    font-size: 13px;\n    line-height: 1.4;\n    color: ink.$text-3;\n  }\n\n  &--reached {\n    opacity: 1;\n\n    .profession-menu-diamond__shape {\n      border-color: var(--gold-main);\n      background: var(--gold-main);\n    }\n    .profession-menu-diamond__rank { color: ink.$text; }\n    .profession-menu-diamond__xp { color: var(--gold-main); }\n    .profession-menu-diamond__reward { color: ink.$text-2; }\n  }\n\n  &--current {\n    opacity: 1;\n\n    .profession-menu-diamond__shape {\n      border-color: var(--gold-light);\n      background: var(--gold-light);\n    }\n    .profession-menu-diamond__rank,\n    .profession-menu-diamond__xp,\n    .profession-menu-diamond__reward { color: var(--gold-light); }\n  }\n\n  // A rank this slot can never reach (2nd job past its Expert cap):\n  // permanently dim, distinct from \"not reached yet\".\n  &--capped {\n    opacity: 0.3;\n\n    .profession-menu-diamond__shape { border-style: dashed; }\n  }\n}\n\n.profession-menu-progress-bar {\n  width: 100%;\n  height: 6px;\n  margin-top: 16px;\n  background: rgba(255, 255, 255, 0.1);\n  border-radius: ink.$radius;\n  overflow: hidden;\n\n  &--hidden {\n    visibility: hidden;\n  }\n\n  &__fill {\n    height: 100%;\n    background: var(--gold-main);\n    transition: width 0.25s ease-out;\n\n    @media (prefers-reduced-motion: reduce) { transition: none; }\n  }\n}\n\n.profession-menu-progress-text {\n  margin-top: 8px;\n  font-size: 13px;\n  color: ink.$text-2;\n  font-variant-numeric: tabular-nums;\n\n  &--hidden {\n    visibility: hidden;\n  }\n}\n\n// Different resource from the XP bar (depletes with use, regenerates), so it\n// uses the success tone instead of the accent.\n.profession-menu-endurance-bar {\n  flex: 1;\n  height: 6px;\n  background: rgba(255, 255, 255, 0.1);\n  border-radius: ink.$radius;\n  overflow: hidden;\n\n  &__fill {\n    height: 100%;\n    background: ink.$success;\n    transition: width 0.25s ease-out;\n\n    @media (prefers-reduced-motion: reduce) { transition: none; }\n  }\n}\n\n// ---------- Info (right) ----------\n\n.profession-menu-info {\n  grid-column: 5;\n  display: flex;\n  flex-direction: column;\n}\n\n.profession-menu-infolist {\n  margin: 0 0 20px;\n\n  div {\n    display: flex;\n    justify-content: space-between;\n    align-items: baseline;\n    gap: 10px;\n    padding: 8px 0;\n    font-size: 14px;\n    border-top: 1px solid ink.$line;\n  }\n\n  dt { color: ink.$text-2; }\n  dd { margin: 0; color: ink.$text; display: flex; align-items: center; gap: 8px; }\n}\n\n.profession-menu-difficulty-dot {\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  display: inline-block;\n  background: ink.$text-3;\n\n  &--facile { background: ink.$success; }\n  &--moyen { background: $warning; }\n  &--difficile { background: ink.$danger; }\n}\n\n.profession-menu-checklist {\n  list-style: none;\n  margin: 0 0 20px;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n\n  li {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    gap: 10px;\n    padding: 8px 0;\n    font-size: 14px;\n    color: ink.$text-2;\n    border-top: 1px solid ink.$line;\n  }\n\n  // CSS-drawn check mark (no glyph ornament).\n  &__check {\n    flex: none;\n    width: 5px;\n    height: 10px;\n    margin-right: 4px;\n    border-right: 2px solid var(--gold-main);\n    border-bottom: 2px solid var(--gold-main);\n    transform: rotate(45deg);\n  }\n}\n\n.profession-menu-tools {\n  display: flex;\n  flex-direction: column;\n}\n\n.profession-menu-tool {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 8px 0;\n  border-top: 1px solid ink.$line;\n\n  &__icon {\n    width: 40px;\n    height: 40px;\n    flex-shrink: 0;\n    color: var(--gold-main);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding: 4px;\n\n    svg {\n      width: 100%;\n      height: 100%;\n    }\n\n    // Small source sprites scaled up: crisp edges, no stretching.\n    img {\n      width: 100%;\n      height: 100%;\n      object-fit: contain;\n      image-rendering: pixelated;\n    }\n  }\n\n  &__name {\n    font-size: 14px;\n    color: ink.$text;\n  }\n}\n\n// ---------- Footer ----------\n\n.profession-menu-footer {\n  flex: 0 0 auto;\n  display: flex;\n  align-items: center;\n  padding: 12px 24px;\n  border-top: 1px solid ink.$line;\n\n  &__hint {\n    flex: 1;\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    font-size: 13px;\n    color: ink.$text-3;\n\n    kbd {\n      font-family: ink.$font-text;\n      font-size: 12px;\n      padding: 2px 8px;\n      color: ink.$text-2;\n      background: ink.$ink-raised;\n      border: 1px solid ink.$line;\n      border-radius: 4px;\n    }\n  }\n\n  &__spacer {\n    flex: 1;\n    display: flex;\n    justify-content: flex-end;\n  }\n}\n\n// Tertiary and destructive: quiet until hovered.\n.profession-menu-reroll-btn {\n  @include ink.button;\n  @include ink.button-quiet;\n  @include ink.button-sm;\n\n  &:hover:not(:disabled) {\n    color: ink.$danger;\n    background: rgba(217, 120, 109, 0.14);\n  }\n}\n\n// The one primary action of the view.\n.profession-menu-choose-btn {\n  @include ink.button;\n  @include ink.button-primary;\n  padding: 10px 28px;\n\n  &:disabled {\n    color: ink.$text-3;\n    background: rgba(255, 255, 255, 0.05);\n    border-color: ink.$line;\n  }\n\n  &--current:disabled {\n    color: var(--gold-light);\n    border-color: var(--gold-dark);\n  }\n}\n\n// ---------- Confirmation dialog ----------\n\n.profession-menu-confirm-overlay {\n  position: absolute;\n  inset: 0;\n  z-index: 3;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: rgba(2, 3, 5, 0.72);\n  @include ink.enter;\n}\n\n.profession-menu-confirm {\n  @include ink.panel;\n  width: min(460px, 86%);\n  padding: 22px 24px;\n\n  &__title {\n    @include ink.title(22px);\n    margin-bottom: 12px;\n  }\n\n  &__text {\n    margin: 0 0 4px;\n    font-size: 15px;\n    line-height: 1.5;\n    color: ink.$text-2;\n  }\n\n  &__profession {\n    display: block;\n    margin: 6px 0 12px;\n    @include ink.title(20px);\n    color: var(--gold-light);\n  }\n\n  &__note {\n    margin-bottom: 18px;\n    @include ink.hint;\n  }\n\n  &__actions {\n    display: flex;\n    justify-content: flex-end;\n    gap: 8px;\n  }\n}\n\n.profession-menu-confirm-btn {\n  @include ink.button;\n\n  &--confirm {\n    @include ink.button-primary;\n  }\n\n  &--danger {\n    @include ink.button-danger;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
